import React from "react";
import { Card } from "./TvBits";

const NAME = { coinbase: "COINBASE", "coinbase-futures": "CB FUTURES", kalshi: "KALSHI", alpaca: "ALPACA", tradier: "TRADIER", tastytrade: "TASTYTRADE",
  alpaca_paper: "ALPACA PAPER", tradier_sandbox: "TRADIER SANDBOX" };
const money = (v) => { const r = Math.round(v); return `${r < 0 ? "-" : r > 0 ? "+" : ""}$${Math.abs(r).toLocaleString()}`; };
const wrColor = (w) => (w == null ? "#64748B" : w >= 60 ? "#10B981" : w >= 40 ? "#F59E0B" : "#EF4444");

const Row = ({ r, best }) => (
  <div className={`grid grid-cols-[1.4fr_1fr_1.2fr_1fr_1fr] items-center gap-3 py-[0.55em] px-3 rounded-xl border ${best ? "border-emerald-400/50 bg-emerald-400/10" : "border-white/5"}`}
    data-testid={`tv-board-${r.broker}`}>
    <b className="nx-orbitron text-[clamp(1rem,1.5vw,1.6rem)] font-black text-cyan-50">{NAME[r.broker] || r.broker.toUpperCase()}{best && <span className="ml-2 text-xs text-emerald-300">★ TOP</span>}</b>
    <span className="nx-mono text-[clamp(1.2rem,1.9vw,2.1rem)] font-black" style={{ color: wrColor(r.win_rate) }}>{r.win_rate == null ? "—" : `${r.win_rate}%`}</span>
    <span className="nx-mono text-[clamp(1.1rem,1.7vw,1.9rem)] font-black" style={{ color: r.profit >= 0 ? "#10B981" : "#EF4444" }}>{money(r.profit)}</span>
    <span className="nx-mono text-lg" style={{ color: r.today >= 0 ? "#6EE7B7" : "#FCA5A5" }}>{money(r.today)}</span>
    <span className="nx-mono text-base text-cyan-100/70">{r.wins}/{r.trades} won · {r.open} open</span>
  </div>
);

const Board = ({ title, rows, accent, testid }) => {
  const best = rows.find((r) => r.trades > 0 && r.profit > 0)?.broker;
  return (
    <Card title={title} accent={accent} code="WIN RATE · TOTAL P&L · TODAY · RECORD" className="h-full" testid={testid}>
      <div className="flex flex-col gap-2">{rows.map((r) => <Row key={r.broker} r={r} best={r.broker === best} />)}</div>
    </Card>
  );
};

export const TvBrokerBoard = ({ d }) => {
  const b = d.broker_board;
  if (!b) return null;
  return (
    <div className="h-full grid grid-rows-[1.7fr_1fr] gap-4" data-testid="tv-scene-broker-board">
      <Board title="BROKER WIN BOARD · LIVE MONEY" rows={b.live} accent="#10B981" testid="tv-board-live" />
      <Board title="HERCULES PRACTICE BOOKS" rows={b.practice} accent="#F59E0B" testid="tv-board-practice" />
    </div>
  );
};
